// Ad slots (roadmap §6.1) and the shapes the ad server returns. Every ad is labeled.

export type SlotId =
  | "world.billboard"
  | "world.ticker"
  | "chirp.sponsored"
  | "farm.featured"
  | "loading.sponsor"
  | "phone.home.banner";

export interface SlotSpec {
  id: SlotId;
  where: string;
  format: "image" | "text" | "post" | "logo";
  maxBytes?: number;
  size?: [number, number];
  maxChars?: number;
}

export const SLOTS: Record<SlotId, SlotSpec> = {
  "world.billboard": { id: "world.billboard", where: "Billboards around the island", format: "image", maxBytes: 150_000, size: [1024, 512] },
  "world.ticker": { id: "world.ticker", where: "Trading Floor tower screen", format: "text", maxChars: 60 },
  "chirp.sponsored": { id: "chirp.sponsored", where: "Chirp feed (max 1 per 12 posts)", format: "post", maxBytes: 100_000 },
  "farm.featured": { id: "farm.featured", where: "Top of the Farm app", format: "image", size: [640, 200], maxBytes: 100_000 },
  "loading.sponsor": { id: "loading.sponsor", where: "Loading screen and season intro", format: "logo", maxBytes: 60_000 },
  "phone.home.banner": { id: "phone.home.banner", where: "Phone home screen (dismissible)", format: "image", size: [640, 160], maxBytes: 80_000 },
};

export const SLOT_IDS = Object.keys(SLOTS) as SlotId[];

export interface ServedAd {
  slot: SlotId;
  campaignId: number;
  creativeId: number;
  advertiser: string;
  title: string;
  text: string;
  imageUrl: string | null;
  clickUrl: string | null;
  house: boolean; // house ad (game tips, season promo, "Advertise here")
}

export interface AdEvent {
  kind: "impression" | "click";
  slot: SlotId;
  campaignId: number;
  creativeId: number;
}

/** House ads: shown when nothing is booked (never paid, never link out except "Advertise here"). */
export const HOUSE_ADS: Omit<ServedAd, "slot">[] = [
  { campaignId: 0, creativeId: 0, advertiser: "Degen World", title: "Advertise here", text: "Reach the trenches. Billboards, Chirp, the Farm.", imageUrl: null, clickUrl: "https://degen.world/advertise", house: true },
  { campaignId: 0, creativeId: -1, advertiser: "Degen World", title: "Tip: touch grass", text: "Heat too high? The park, coffee and your bed cool it down.", imageUrl: null, clickUrl: null, house: true },
  { campaignId: 0, creativeId: -2, advertiser: "Degen World", title: "Never share a seed phrase", text: "Nothing in this game uses real money. Scam DMs are a lesson, not a bug.", imageUrl: null, clickUrl: null, house: true },
];

/** Ad policy keywords (§6.3): auto-flag for the manual review (a human still approves every ad). */
export const AD_POLICY_FLAGS = [
  /connect (your )?wallet/i,
  /sign (the |a )?(transaction|message)/i,
  /\bclaim\b.*\b(token|airdrop|reward)/i,
  /guarantee(d)? (returns?|profit)/i,
  /send \d+.*get \d+/i,
  /\b(2x|double) your\b/i,
  /deposit to (win|enter)/i,
  /\b(casino|betting|porn|xxx)\b/i,
  /seed phrase|private key/i,
];

export function adPolicyIssues(text: string): string[] {
  return AD_POLICY_FLAGS.filter((r) => r.test(text)).map((r) => r.source);
}
